/**
 * A link that OPENS A WORKLIST (the daily missing-documents notice, plan "deal gates" R18 §4.5): the list it
 * lands on must show exactly the selection its URL names, even when the reader is already on that list with
 * a search, other filters or a later page of their own. The link navigates with this router state; the list
 * page, seeing it on a new location, drops its local search, filters and page so the URL is the only source
 * of the selection. An ordinary URL change (the page's own filter writes) carries no state and keeps them.
 */

/** The router state a worklist link navigates with. */
export const FRESH_WORKLIST_STATE = { freshWorklist: true } as const;

/** Whether a location's state marks it as a fresh worklist navigation. */
export function isFreshWorklist(state: unknown): boolean {
  return (
    typeof state === 'object' &&
    state !== null &&
    (state as { freshWorklist?: unknown }).freshWorklist === true
  );
}
